import { buildTheme, getCurrentMode } from "../Styles/theme";
// Functions
import { tierListFunctions } from "./tierListFunctions";
import { notificationHandler } from "./Handlers/notificationHandler";
import { getCommands } from "../Scripts/Database/GET/getCommands";
import { postCommands } from "../Scripts/Database/POST/postCommands";
import { updateCommands } from "../Scripts/Database/UPDATE/updateCommands";
import { createCommands } from "../Scripts/Database/CREATE/createCommands";
export const basicFunctions = {
  //

  updateState(prop) {
    this.setState(prop);
  },

  formatTime(seconds) {
    const mins = Math.floor(seconds / 60);
    const secs = Math.floor(seconds % 60);
    return `${mins}:${secs.toString().padStart(2, "0")}`;
  },

  getTheme() {
    return buildTheme(getCurrentMode());
  },

  getFunctionFiles() {
    const scripts = [
      { name: "getCommands", item: getCommands },
      { name: "updateCommands", item: updateCommands },
      { name: "postCommands", item: postCommands },
      { name: "createCommands", item: createCommands },
      { name: "tierListFunctions", item: tierListFunctions },
      { name: "notificationHandler", item: notificationHandler },
    ];
    return scripts;
  },

  getMonthNumber(month) {
    const monthMap = {
      January: 0,
      February: 1,
      March: 2,
      April: 3,
      May: 4,
      June: 5,
      July: 6,
      August: 7,
      September: 8,
      October: 9,
      November: 10,
      December: 11,
    };
    return monthMap[month];
  },

  getAlbumFolder(albumId) {
    let folderPath;
    for (let x = 500; x < 10000; x += 500) {
      let min = x - 499;
      let max = x;
      if (albumId <= x) {
        folderPath = `${min}_${max}`;
        break;
      }
    }
    return folderPath;
  },

  getAlbumArt(albumId) {
    let albumPath = this.basicFunctions.getAlbumFolder(albumId);
    let albumArt = `https://musictierlist.com/AlbumImages/Album_${albumId}.jpg?nocache=${Date.now()}`;
    if (albumPath !== undefined) {
      albumArt = `https://musictierlist.com/AlbumImages/${albumPath}/Album_${albumId}.jpg?nocache=${Date.now()}`;
    }
    return albumArt;
  },

  generateThumbnail(base64Image: string, maxWidth = 400, quality = 0.5): Promise<string> {
    return new Promise((resolve) => {
      const img = new Image();
      img.onload = () => {
        const canvas = document.createElement("canvas");
        const ratio = maxWidth / img.width;
        canvas.width = maxWidth;
        canvas.height = img.height * ratio;
        const ctx = canvas.getContext("2d");
        if (ctx) {
          ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
        }
        resolve(canvas.toDataURL("image/jpeg", quality));
      };
      img.src = base64Image;
    });
  },

  //
};
